import { useState } from "react";

export type PaginationType = {
  page: number;
  size: number;
};

export const usePagination = () =>
  useState<PaginationType>({ page: 0, size: 10 });
